<script lang="ts">
  import { GraphQLClient } from "graphql-request";
  import { getSdk } from "./frontendGatewaySdk";
  import { setAppContext } from "./AppContext";
  import HexTheme, { hexToRGB } from "@cohesionib/biblioteca/lib/HexTheme";

  import { frontendGatewayGraphqlAPIURL } from "./urls";
  import Insights from "./Insights.svelte";

  export let authToken: string;
  export let themeFont: string;
  export let themeAccentColor: string;
  export let buildingCode: string;

  const gqlClient = new GraphQLClient(frontendGatewayGraphqlAPIURL);
  const feGatewaySdk = getSdk(gqlClient);

  // Retool/Butlr Dashboard - Public Link
  const retoolPublicLink = {
    cohesion: '6f6ecbb8-6832-431b-8f34-a2f72e313fea',
    rmr: 'cafb9460-e934-4669-b306-5f3e25e587f6',
    ion: '037a25ea-2af8-4400-b53f-4acbd1943836',
  }

  // List of hardcoded building code in lower case. Used for Demo purpose.
  const buildingCodeDemoList = ['wwsf1', 'thb', 'abnd', 'abnddemo'];
  const buildingButlrSensorList = {
    'tnpl': retoolPublicLink.rmr,
    '1kfm': retoolPublicLink.rmr,
    '1145dc': retoolPublicLink.rmr,
    '4201m': retoolPublicLink.ion,
    '100sw': retoolPublicLink.cohesion,
    'abnddemo': retoolPublicLink.cohesion
  };
  const retoolButlrDashboardURL = 'https://cohesion.retool.com/embedded/public/';

  setAppContext({
    feGatewaySdk,
    buildingCode,
    themeAccentColorHEX: themeAccentColor,
    themeAccentColorRGB: hexToRGB(themeAccentColor),
    buildingCodeDemoList,
    buildingButlrSensorList,
    retoolButlrDashboardURL,
  });
</script>

<main>
  <HexTheme hexColor={themeAccentColor}>
    <Insights {buildingCode} {authToken} {themeFont} {themeAccentColor} />
  </HexTheme>
</main>
